module.exports = require("@splunk/moment");